// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
  aws_app_analytics: 'enable',
  aws_cognito_identity_pool_id: 'us-east-1:2b4c773c-5323-427b-920b-03a7497824af',
  aws_cognito_region: 'us-east-1',
  aws_content_delivery: 'enable',
  aws_content_delivery_bucket: 'artpptest-hosting-mobilehub-1073142719',
  aws_content_delivery_bucket_region: 'us-east-1',
  aws_content_delivery_cloudfront: 'enable',
  aws_content_delivery_cloudfront_domain: 'dolpivu26x3vx.cloudfront.net',
  aws_mobile_analytics_app_id: '43fb6692a987426cb8d894b3d74bf821',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_project_id: '4ff20ec2-0e90-418b-b2aa-6765b05eeee9',
  aws_project_name: 'artpptest_MobileHub',
  aws_project_region: 'us-east-1',
  aws_resource_name_prefix: 'artpptest-mobilehub-1073142719',
};

export default awsmobile;
